<div class="text-7xl" i18n>
  Products
</div>
<div class="relative">
  <!-- da vedere su mobile se va modificata  la itemWidth -->
  <paged-virtual-scroller
    #virtualScroller
    class="mb-6"
    [scrollWithMainScrollbar]="true"
    [itemTpl]="productScrollerTpl"
    [itemHeight]="290"
    [itemWidth]="305"
    [pageSize]="16"
    [scaleUpOnRender]="scaleUpOnRender"
    seoFriendly="offset-cursor"
    [itemsQuery]="productsQuery"
    [renderOnTimeOut]="0">
  </paged-virtual-scroller>
</div>


<ng-template let-item #productScrollerTpl>
  <product-block
    class="w-[290px] h-[275px]"
    #productBlock
    [urlPrefix]="urlPrefix"
    [productItem]="item"
    [imageSizes]="[{w: 298, h: 168, resizeMode: 'fill'}]"
    [itemListId]="itemListId"
    [itemListName]="itemListName">
  </product-block>
</ng-template>

